import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import {styled} from '@mui/material/styles';

export const StyledSectionContentContainer = styled(Box)(() => ({
  display: 'flex',
  width: '100%',
  flexDirection: 'column',
  position: 'relative'
}));

export const StyledPointsChip = styled(Chip)(({theme}) => ({
  borderRadius: theme.spacing(0.5),
  padding: theme.spacing(1),
  borderColor: theme.palette.grey[300],
  fontSize: theme.typography.button.fontSize,
  [theme.breakpoints.down('md')]: {
    fontSize: theme.typography.caption.fontSize
  }
}));

export const BasketProductWrapper = styled(Box)<{isReactNativeView?: boolean}>(({theme, isReactNativeView}) => ({
  paddingLeft: isReactNativeView ? theme.spacing(1) : theme.spacing(2),
  paddingRight: isReactNativeView ? theme.spacing(1) : theme.spacing(2)
}));

export const StyledSectionWrap = styled(Box)<{isReactNativeView?: boolean}>(({theme, isReactNativeView}) => ({
  display: 'flex',
  width: '100%',
  flexDirection: 'row',
  position: 'relative',
  margin: isReactNativeView ? '8px' : '20px',
  maxWidth: '-webkit-fill-available',
  borderRadius: '12px',
  backgroundColor: theme.palette.common.white,
  '&.multiple': {
    [theme.breakpoints.down('md')]: {
      marginBottom: isReactNativeView ? theme.spacing(1) : theme.spacing(2)
    }
  },
  '&.v2': {
    marginBottom: ''
  }
}));

export const StyledSectionWrapV2 = styled(Box)<{isReactNativeView?: boolean}>(({theme, isReactNativeView}) => ({
  display: 'flex',
  width: '100%',
  flexDirection: 'row',
  position: 'relative',
  margin: isReactNativeView ? '8px' : '20px',
  maxWidth: '-webkit-fill-available',
  borderRadius: '12px',
  backgroundColor: theme.palette.common.white,
  '&.multiple': {
    [theme.breakpoints.down('md')]: {
      marginBottom: isReactNativeView ? theme.spacing(1) : theme.spacing(2)
    }
  }
}));

export const StyledUnavailableSectionHeader = styled(Box)<{isReactNativeView?: boolean}>(({theme}) => ({
  borderRadius: '12px 12px 0px 0px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  backgroundColor: theme.palette.grey[200],
  padding: '8px 16px 8px 16px'
}));
